// @flow

import React from 'react';

import Slider from '../../components/Slider';
import SliderElement from '../../components/SliderElement';
import { AREA_DATA, AREA_MAP, AREA_MEDIA } from '../../path/areaPath';
import AreaData from '../area/data/AreaData';
import Media from '../area/media/Media';
import GenericMapContainer from '../common/GenericMapContainer';
import AreaMap from '../area/map/AreaMap';

type Props = {
}

type State = {
  currentSlideIndex: number,
}

class AreaBase extends React.Component<Props, State> {
  state: State = {
    currentSlideIndex: 0,
  };

  render() {
    return (
      <div className="slider-container">
        <Slider
          goTopOnUpdate
          updateCurrentSlide={currentSlide =>
            this.setState({ currentSlideIndex: currentSlide })
          }
          currentSlide={this.state.currentSlideIndex}
        >
          <SliderElement path={AREA_MAP} render={<GenericMapContainer map={<AreaMap />} />} />
          <SliderElement path={AREA_DATA} render={<AreaData />} />
          <SliderElement path={AREA_MEDIA} render={<Media />} />
        </Slider>
      </div>
    );
  }
}

export default AreaBase;
